<template>
<div class="chapter">
<div class="inner_page">
<p class="ctl" id="d12e374"><a href="#/Wals_ISBN1418537640_epub_c4_r1#d12e124" id="d12e375">part 1</a></p>
<p class="h1l" id="d12e377"><a href="#/Wals_ISBN1418537640_epub_c4_r1#d12e124" id="d12e378">the</a></p>
<p class="h1l" id="d12e380"><a href="#/Wals_ISBN1418537640_epub_c4_r1#d12e124" id="d12e381">path</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wals_ISBN1418537640_epub_c7_r1.vue?40329c27